import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import Divider from '../../Shared/UI/Divider/components/Divider';
import Button from '../../Shared/UI/Button/components/Button';
import PlusIcon from '../../Shared/UI/PlusIcon/components/PlusIcon';
import ProfileUserEducation from './ProfileUserEducation';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import NewUserEducationForm from './NewUserEducationForm';
import UpdateUserEducationForm from './UpdateUserEducationForm';
import DeleteUserEducationForm from './DeleteUserEducationForm';

import styles from './ProfileUserEducations.module.scss';

const ProfileUserEducations = () => {
  const state = useProfileState();
  const { openNewUserEducationModal, closeNewUserEducationModal, closeUpdateUserEducationModal, closeDeleteUserEducationModal } = useProfileActions();

  const titleStyling = state?.user?.educations?.length ? null : styles.visibleOnlyToYou;

  if (state.loading) {
    return (
      <section id={styles.userEducationsSection}>
        <Divider />
        <div id={styles.userEducationsLoading} />
      </section>
    );
  }

  return (
    <>
      {(state?.user?.educations?.length || state?.user?.isAuthenticatedUser) && (
        <section id={styles.userEducationsSection}>
          <Divider />
          <div id={styles.userEducationsSectionHeader}>
            <h2 className={titleStyling}>
              Education
            </h2>
            {state?.user?.isAuthenticatedUser && (
              <Button
                variant="ghost"
                icon={<PlusIcon />}
                iconOnly
                aria-label="Add Education"
                onClick={() => {
                  if (state?.user?.isAuthenticatedUser) {
                    openNewUserEducationModal();
                  }
                }}
              />
            )}
          </div>
          {state?.user?.educations?.length ? (
            <div id={styles.userEducations}>
              {state?.user?.educations?.map((education, index) => {
                if (index === state?.user?.educations.length - 1) {
                  return <ProfileUserEducation key={education.id} education={education} />;
                }

                return (
                  <React.Fragment key={education.id}>
                    <ProfileUserEducation education={education} />
                    <Divider variant="secondary"/>
                  </React.Fragment>
                );
              })}
            </div>
          ) : (
            <p className={styles.visibleOnlyToYou}>
              This section is currently only visible to you since you have not added any education to display yet.
            </p>
          )}
        </section>
      )}
      <StandardModal
        isOpen={state?.newUserEducationModalIsOpen}
        contentLabel={'Add Your Education'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeNewUserEducationModal();
          }
        }}
      >
        <NewUserEducationForm />
      </StandardModal>
      <StandardModal
        isOpen={state?.updateUserEducationModalIsOpen}
        contentLabel={'Update Your Education'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeUpdateUserEducationModal();
          }
        }}
      >
        <UpdateUserEducationForm />
      </StandardModal>
      <StandardModal
        isOpen={state?.deleteUserEducationModalIsOpen}
        contentLabel={'Delete This Education'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeDeleteUserEducationModal();
          }
        }}
      >
        <DeleteUserEducationForm />
      </StandardModal>
    </>
  );
};

export default ProfileUserEducations;
